export default __webpack_public_path__ + "static/media/mars13.7491a808.gif";